<div class="container">

	<div class="portalCard">

		<div
			class="aTitle"
			(click)="bFGVisible = !bFGVisible"
		>
			<mat-icon>group_work</mat-icon>
			<span>Dokumentengruppen</span>
		</div>

		<div
			*ngIf="bFGVisible"
			class="management"
		>
			<app-file-group-management />
		</div>

	</div>

	<div class="portalCard">

		<div
			class="aTitle"
			(click)="bCGVisible = !bCGVisible"
		>
			<mat-icon>group_work</mat-icon>
			<span>Veranstaltungsgruppen</span>
		</div>

		<div
			*ngIf="bCGVisible"
			class="management"
		>
			<app-calendar-group-management />
		</div>

	</div>

	<div class="portalCard">

		<div
			class="aTitle"
			(click)="bRVisible = !bRVisible"
		>
			<mat-icon>group_work</mat-icon>
			<span>News Rubriken</span>
		</div>

		<div
			*ngIf="bRVisible"
			class="management"
		>
			<app-rubric-management />
		</div>

	</div>

	@if( environment.features.austausch ) {

		<div class="portalCard">
	
			<div
				class="aTitle"
				(click)="bDECVisible = !bDECVisible"
			>
				<mat-icon>group_work</mat-icon>
				<span>Austauschkategorien</span>
			</div>

			<div
				*ngIf="bDECVisible"
				class="management"
			>
				<app-document-exchange-management />
			</div>
	
		</div>

	}

</div>
